
export default class Configs {
    public static API_ROOT:string = 'https://ondigoapi.intellexio.com';
    public static API_URL:string = 'https://ondigoapi.intellexio.com/api/';
}
